/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CreateUserBodyDTO } from '../model/models';
import { UserDetailDTO } from '../model/models';
import { UsersResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateUserRequestParams {
    createUserBodyDTO: CreateUserBodyDTO;
}

export class ClsCreateUserRequestParams {
    createUserBodyDTO: CreateUserBodyDTO = undefined;
}

export interface DeleteM2MUserRequestParams {
    fccId: string;
}

export class ClsDeleteM2MUserRequestParams {
    fccId: string = undefined;
}

export interface DeleteTenantGroupRequestParams {
    tenantId: string;
}

export class ClsDeleteTenantGroupRequestParams {
    tenantId: string = undefined;
}

export interface GetUserRequestParams {
    userId: string;
    crossRealm?: boolean;
}

export class ClsGetUserRequestParams {
    userId: string = undefined;
    crossRealm?: boolean = undefined;
}

export interface GetUsersRequestParams {
    email?: string;
    firstNameSearch?: string;
    lastNameSearch?: string;
    role?: string;
    userName?: string;
    userNameSearch?: string;
    search?: string;
    tenantId?: Array<string>;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsGetUsersRequestParams {
    email?: string = undefined;
    firstNameSearch?: string = undefined;
    lastNameSearch?: string = undefined;
    role?: string = undefined;
    userName?: string = undefined;
    userNameSearch?: string = undefined;
    search?: string = undefined;
    tenantId?: Array<string> = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}


export interface AdminApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new user with tenantId from body
     * 
* @param requestParameters
     */
    createUser(requestParameters: CreateUserRequestParams, extraHttpRequestParams?: any): Observable<UserDetailDTO>;

    /**
     * Delete user from m2m realm
     * 
* @param requestParameters
     */
    deleteM2MUser(requestParameters: DeleteM2MUserRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete the group and its users for a tenant
     * 
* @param requestParameters
     */
    deleteTenantGroup(requestParameters: DeleteTenantGroupRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Retrieve detail of user
     * Get a detail of user
* @param requestParameters
     */
    getUser(requestParameters: GetUserRequestParams, extraHttpRequestParams?: any): Observable<UserDetailDTO>;

    /**
     * Retrieve list of users
     * Search and filter users, it could filter by multiple tenant ids.
* @param requestParameters
     */
    getUsers(requestParameters: GetUsersRequestParams, extraHttpRequestParams?: any): Observable<UsersResponseDTO>;

    /**
     * Migration of roles and scopes
     * 
*/
    migration(extraHttpRequestParams?: any): Observable<{}>;

}
